<template>
    <v-card>
        <v-card-text>
            <datatable
                :label="'Datenschutzbeauftragte'"
                :headers="[{text: 'Name', value: 'fullname'}, {text: 'E-Mail', value: 'email'}, {text: '', value: ''}]"
                :items="preparedDsbs"
            >
                <template v-slot:items="props">
                    <td>
                        {{props.item.fullname}}
                    </td>
                    <td>
                        {{props.item.email}}
                    </td>
                    <td>
                        <v-btn icon @clich="delete(props.item.userId)">
                            <v-icon>
                                delete
                            </v-icon>
                        </v-btn>
                    </td>
                </template>
            </datatable>
        </v-card-text>
        <v-dialog></v-dialog>
    </v-card>
</template>

<script>
import DatatableVue from './Datatable.vue'
export default {
    name: 'Admin',

    components: {
        'datatable': DatatableVue
    },

    data: () => ({
        search: '',

        dsbs: [],
        clients: [],

        selectedClient: {
            name: '',
            clientId: ''
        }
    }),

    computed: {
        preparedDsbs() {
            return this.dsbs.map( dsb => {
                dsb.fullname = `${dsb.salutation} ${(dsb.title ? dsb.title : '')} ${dsb.firstname} ${dsb.lastname}` 
                return dsb
            })
        }
    },

    mounted() {
        this.fetchAllClients();
        this.fetchAllDSBs();
    },

    methods: {
        fetchAllDSBs() {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/monitor/dsbs",
                data: {},
                success: (response) => {
                    self.setDsbs(response.data);
                }
            });
        },

        fetchAllClients() {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/client/allclients",
                method: 'GET',
                data: {},
                success: (response) => {
                    self.setClients(response.data);
                }
            });
        },

        setClients(clients) {
            this.clients = clients;
        },

        setDsbs(dsbs) {
            this.dsbs = dsbs;
        },

        invite() {

        },

        delete(userId) {
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/user/role/delete/" + userId,
                data: {
                    clientId,
                    userRole: 'DSB'
                },
                blockGui: false,
                success: function(response) {
                    // EventBus.$emit('updateRoles');
                    self.fetchDsbs();
                }
            });
        }
    }
}
</script>

<style>

</style>